/**
 * @description: 价格策略
 * @author: hwx
 * @update: lyr(2022-03-17)
*/
<template>
	<div class="price-strategy">
		<div class="prs-list" v-show="showList">
			<el-row>
				<el-button type="primary" @click="prsAdd" v-if="list_menu_add">新增价格策略</el-button>
				<p>注：当适用包厢设置为全部时，APP收银开房时开启可选餐牌策略功能<br />若适用包厢设置不是为全部包厢时，则APP收银根据设置条件优先使用餐牌策略内价格</p>
			</el-row>
			<el-form :inline="true" :model="prs_list_form">
                <el-form-item label="门店">
                    <el-select v-model="prs_list_form.shop_id" filterable>
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="prs_list_form.status" clearable placeholder="请选择状态">
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="禁用" value="-1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="策略名称">
                    <el-input placeholder="请输入策略名称" v-model="prs_list_form.name"></el-input>
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="getPrsTable(1)">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="prs_table">
                <el-table-column prop="shop_name" label="适用门店"></el-table-column>
                <el-table-column prop="name" label="策略名称"></el-table-column>
                <el-table-column prop="room_name" label="适用包厢"></el-table-column>
                <el-table-column label="适用时间段">
					<template slot-scope="scope">
                        {{scope.row.use_start_time + '~' + scope.row.use_end_time}}
                    </template>
				</el-table-column>
                <el-table-column label="适用时间区间">
                    <template slot-scope="scope">
                        {{scope.row.use_start_hour + '~' + scope.row.use_end_hour}}
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="prsModify(scope.row.id)" v-if="list_menu_modify">修改</span>
                        <span class="text-blue" @click="prsDel(scope.row.id)" v-if="list_menu_del">删除</span>
						<span class="text-blue" @click="prsStatus(scope.row.id, -(scope.row.status))">
							{{scope.row.status == '1' ? '禁用' : '启用'}}
						</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="prs_page"
                :total="prs_total"
                @current-change="getPrsTable">
            </el-pagination>
		</div>
		<div class="prs-edit" v-show="showEdit">
			<h2>{{prs_edit_tit}}</h2>
			<p>注：价格策略设置成功后在显示端显示执行价格策略设置的价格</p>
			<div class="prs-edit-base">
				<h3>基本资料</h3>
				<el-form :model="prs_edit_form" label-width="130px">
					<el-form-item label="门店">
						<el-select v-model="prs_edit_form.shop_id" :disabled="prs_edit_form.shop_disabled" filterable placeholder="请选择门店" @change="prsShopChange">
							<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="策略名称">
						<el-input placeholder="请输入规则名称。例如：vip区价格策略" v-model="prs_edit_form.name"></el-input>
						<el-checkbox v-model="prs_edit_form.relate_bill" :true-label="'1'" :false-label="'-1'">关联账单</el-checkbox>
						<el-popover
							placement="right"
							trigger="hover"
							title="说明：">
							<p>勾选关联账单后，账单及商品相关报表可通过检索对应价格策略名称查询数据</p>
							<i class="el-icon-question my-el-hint" slot="reference"></i>
						</el-popover>
					</el-form-item>
					<el-form-item label="适用包厢">
						<el-input v-model="prs_room_txt" class="el-ellipsis" clearable placeholder="请选择包厢号" @focus="prsRoomSelect" @clear="prsRoomDel"></el-input>
					</el-form-item>
					<el-form-item label="适用时间段" class="prs-usedate-wrap">
						<div ref="prs_usedate_main" class="prs-usedate-main">
							<el-input v-model="prs_usedate_txt" class="el-ellipsis" placeholder="请选择适用时间段"></el-input>
						</div>
					</el-form-item>
					<el-form-item label="适用时间区间">
						<el-input v-model="prs_usetime_txt" class="el-ellipsis" placeholder="请选择适用时间区间" @click.native="prsUsetime"></el-input>
					</el-form-item>
					<el-form-item label="有效星期几">
						<el-input v-model="prs_week_txt" class="el-ellipsis" clearable placeholder="请选择有效星期几" @focus="prsWeekSelect" @clear="prsWeekDel"></el-input>
					</el-form-item>
					<el-form-item label="商品规则">
						<el-select v-model="prs_edit_form.use_rule">
							<el-option label="显示所有商品" value="1"></el-option>
							<el-option label="仅显示价格策略商品" value="2"></el-option>
						</el-select>
						<el-popover
							placement="right"
							trigger="hover">
							<p>显示全部商品指：当前包厢显示门店设置的全部商品。</p>
							<p>仅显示价格策略商品指：当前包厢只是显示当前设置价格策略的商品，其他商品不显示。</p>
							<i class="el-icon-question my-el-hint" slot="reference"></i>
						</el-popover>
					</el-form-item>
					<el-form-item label="预估成本价" v-show="vip_shareholder_status">
						<el-input placeholder="请输入预估成本价" v-model="prs_edit_form.forecast_cost_price"></el-input>
						<el-popover
							placement="right"
							trigger="hover">
							<p>用以计算商品利润的一个数值</p>
							<p>商品利润=（商品折后价-预估成本价）*毛利</p>
							<i class="el-icon-question my-el-hint" slot="reference"></i>
						</el-popover>
					</el-form-item>
					<el-form-item label="毛利百分比" v-show="vip_shareholder_status">
						<el-input placeholder="请输入毛利百分比" v-model="prs_edit_form.gross_margin_ratio">
							<template slot="append">%</template>
						</el-input>
						<el-popover
							placement="right"
							trigger="hover">
							<p>用以计算商品利润的一个数值</p>
							<p>商品利润=（商品折后价-预估成本价）*毛利</p>
							<i class="el-icon-question my-el-hint" slot="reference"></i>
						</el-popover>
					</el-form-item>
				</el-form>
			</div>
			<div class="prs-edit-goods">
				<h3>适用商品</h3>
				<el-row v-show="prs_edit_id == ''">
					<el-button type="primary" class="pull-right" @click="goodsSelect">添加商品</el-button>
				</el-row>
				<el-form v-show="prs_edit_id != ''" :inline="true" :model="edit_goods_form">
					<el-form-item label="商品类型">
						<el-select v-model="edit_goods_form.goods_type" clearable placeholder="请选择商品类型">
							<el-option v-for="item in edit_goodstype_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品名称">
						<el-input placeholder="请输入商品名称" v-model="edit_goods_form.goods_name"></el-input>
					</el-form-item>
					<el-form-item class="pull-right">
						<el-button type="primary" @click="goodsSelect">添加商品</el-button>
						<el-button type="primary" @click="getPrsGoodsDetail">查询</el-button>
					</el-form-item>
				</el-form>
				<el-table
					v-loading="loading"
					element-loading-text="努力加载中，请稍后..."
					element-loading-background="rgba(0, 0, 0, 0.6)"
					:header-cell-style="{background:'#ccc'}"
					:data="edit_goods_table">
					<el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
					<el-table-column label="商品图片">
						<template slot-scope="scope">
							<img :src="scope.row.good_img" class="edit-goods-img">
						</template>
					</el-table-column>
					<el-table-column prop="goods_name" label="商品名称"></el-table-column>
					<el-table-column prop="goods_unit_name" label="单位"></el-table-column>
					<el-table-column label="价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="价格策略" v-model="edit_goods_table[scope.$index].discount_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'discount_price', scope.row.discount_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="会员价格策略" v-model="edit_goods_table[scope.$index].vip_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_price', scope.row.vip_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="一级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="一级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level1_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level1_price', scope.row.vip_level1_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="二级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="二级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level2_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level2_price', scope.row.vip_level2_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="三级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="三级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level3_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level3_price', scope.row.vip_level3_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="四级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="四级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level4_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level4_price', scope.row.vip_level4_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="五级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="五级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level5_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level5_price', scope.row.vip_level5_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="六级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="六级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level6_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level6_price', scope.row.vip_level6_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="七级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="七级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level7_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level7_price', scope.row.vip_level7_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="八级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="八级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level8_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level8_price', scope.row.vip_level8_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="九级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="九级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level9_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level9_price', scope.row.vip_level9_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="十级会员价格策略" width="100">
						<template slot-scope="scope">
							<el-input placeholder="十级会员价格策略" v-model="edit_goods_table[scope.$index].vip_level10_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'vip_level10_price', scope.row.vip_level10_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="原价" width="100">
						<template slot-scope="scope">
							<el-input placeholder="原价" v-model="edit_goods_table[scope.$index].cost_price" class="prs-table-input" @blur="editGoodsPrice(scope.row, 'cost_price', scope.row.cost_price)"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right">
						<template slot-scope="scope">
							<span class="text-blue" @click="editGoodsDel(scope.row)">删除</span>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					background
					layout="total, prev, pager, next, jumper"
					:page-size="GLOBAL.PAGESIZE"
					:current-page.sync="edit_goods_page"
					:total="edit_goods_total"
					@current-change="getEditGoodsTable">
				</el-pagination>
			</div>
			<el-row>
				<el-button @click="prsBack">返回</el-button>
                <el-button type="primary" @click="prsEdit">保存</el-button>
			</el-row>
			<!-- 使用时间 -->
			<div class="use-time-wrap" ref="prs_usetime_alert">
				<h2>开始时间：</h2>
				<el-row>
					<el-col :span="11">
						<el-select v-model="prs_hour_start" filterable>
							<el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
						</el-select>
					</el-col>
					<el-col class="el-line" :span="2">:</el-col>
					<el-col :span="11">
						<el-select v-model="prs_minute_start" filterable>
							<el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
						</el-select>
					</el-col>
				</el-row>
				<h2>结束时间：</h2>
				<el-row>
					<el-col :span="11">
						<el-select v-model="prs_hour_end" filterable>
							<el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
						</el-select>
					</el-col>
					<el-col class="el-line" :span="2">:</el-col>
					<el-col :span="11">
						<el-select v-model="prs_minute_end" filterable>
							<el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
						</el-select>
					</el-col>
				</el-row>
			</div>
			<!-- 星期 -->
			<div class="export-wrap" ref="prs_week_alert">
				<el-checkbox :indeterminate="prs_week_sign" v-model="prs_week_all" @change="prsWeekAll">全选</el-checkbox>
				<el-checkbox-group v-model="prs_week_ids" @change="prsWeekChange">
					<el-checkbox label="1">星期一</el-checkbox>
					<el-checkbox label="2">星期二</el-checkbox>
					<el-checkbox label="3">星期三</el-checkbox>
					<el-checkbox label="4">星期四</el-checkbox>
					<el-checkbox label="5">星期五</el-checkbox>
					<el-checkbox label="6">星期六</el-checkbox>
					<el-checkbox label="0">星期日</el-checkbox>
				</el-checkbox-group>
			</div>
			<!-- 添加商品弹窗 -->
			<div class="select-goods-wrap" ref="goods_alert">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-select v-model="goods_type_name" clearable filterable placeholder="请选择类型" @change="goodsTypeChange">
							<el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item"></el-option>
						</el-select>
					</el-col>
					<el-col :span="10">
						<el-input placeholder="请输入商品名称" v-model="goods_name"></el-input>
					</el-col>
					<el-col :span="6">
						<el-button class="pull-right" type="primary" @click="getGoodsTable(1)">查询</el-button>
					</el-col>
				</el-row>
				<el-table
					v-loading="goods_loading"
					element-loading-text="努力加载中，请稍后..."
					element-loading-background="rgba(0, 0, 0, 0.6)"
					ref="goods_table"
					:data="goods_table"
					@selection-change="getSelectGoods">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="goods_type_name" label="类型"></el-table-column>
					<el-table-column
						v-for="(item, index) in goods_columns"
						:key="index"
						:prop="item.prop"
						:label="item.label">
					</el-table-column>
				</el-table>
				<el-pagination
					background
					layout="total, prev, pager, next, jumper"
					:page-size="GLOBAL.PAGESIZEMINI"
					:current-page.sync="goods_page"
					:total="goods_total"
					@current-change="getGoodsTable">
				</el-pagination>
			</div>
		</div>
		<!-- 包厢号 -->
		<div class="multi-page" v-show="showRoom">
			<div class="page-tit">选择包厢</div>
			<p>请选择包厢范围</p>
			<div class="multi-page-main">
				<div class="multi-page-row">
					<div>
						<input type="checkbox" v-model='prs_room_all' @click='prsRoomAll'>
						<span>全部</span>
					</div>
					<ul></ul>
				</div>
				<div class="multi-page-row" v-for="(items, index) in prs_room_arr" :key="items.room_area">
					<div>
						<input type="checkbox" v-model='prs_room_floor' :value="items.room_area" @click="prsRoomFloor(items.room_area, index)">
						<span>{{items.room_area_name}}</span>
					</div>
					<ul class="clearfix">
						<li v-for="item in items.room" :key="item.id">
							<input type="checkbox" v-model='prs_room_item' :value="item.id">
							<span>{{item.name}}</span>
						</li>
					</ul>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="prsRoomBack">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="prsRoomSave">确定</button>
			</div>
		</div>

	</div>
</template>
<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				list_menu_add: false,
            	list_menu_modify: false,
				list_menu_del: false,
            	vip_shareholder_status: '',
                loading: false,
				goods_loading: false,
				showList: true,
                showEdit: false,
                showRoom: false,
                shop_list: [],
				week_list: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],

                prs_list_form: {
                    shop_id: '',
                    status: '1',
                    name: ''
                },
                prs_page: 1,
				prs_total: 0,
				prs_table: [],

				prs_edit_id: '',
                prs_edit_tit: '',
                prs_edit_form: {
					shop_id: '',
					shop_disabled: false,
					relate_bill: '',
                    name: '',
					use_rule: '',
					forecast_cost_price: '',
					gross_margin_ratio: ''
				},
				prs_room_txt: '',
				prs_room_all: false,
                prs_room_item: [],
				prs_c_room_item: [],
				prs_room_floor: [],
				prs_room_arr: [],
				prs_room_arr_det: [],
				prs_usedate_txt: '',
				prs_usedate_start: '',
                prs_usedate_end: '',
                prs_usetime_txt: '',
                prs_usetime_start: '',
                prs_usetime_end: '',
                prs_hour_start: '00',
                prs_minute_start: '00',
                prs_hour_end: '00',
                prs_minute_end: '00',
                prs_week_txt: '',
				prs_week_sign: false,
				prs_week_all: false,
				prs_week_ids: [],
				edit_goodstype_list: [{
					id: "-1",
					name: "商品套餐"
				}],
				edit_goods_form: {
					goods_type: '',
					goods_name: ''
				},
                edit_goods_page: 1,
				edit_goods_total: 0,
				edit_goods_table: [],
				edit_goods_table_all: [],
				edit_goods_add: [],
				edit_goods_edit: [],
				edit_goods_del: [],
				goods_type: '',
				goods_type_name: '',
				goods_type_sign: '',
				goods_type_list: [{
					id: "-2",
					name: "商品套餐",
					type: 'package',
					type_id: ''
				}],
				goods_name: '',
				goods_page: 1,
				goods_total: 0,
				goods_columns: [],
				goods_table: [],
			}
		},
		watch: {
			prs_room_item: {
				handler: function(val, oldVal) {
					const _this = this;

					if(_this.prs_room_item.length >= _this.prs_room_arr_det.length) {
						_this.prs_room_all = true;
					} else {
						_this.prs_room_all = false;
					}

					$.each(_this.prs_room_arr, function(k, v) {
						if(_this.prs_room_item.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.prs_room_item.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.prs_room_floor.indexOf(v.room_area) == -1) {
										_this.prs_room_floor.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.prs_room_floor.indexOf(v.room_area);
									if(index != -1) {
										_this.prs_room_floor.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.prs_room_floor.indexOf(v.room_area);
							if(index != -1) {
								_this.prs_room_floor.splice(index, 1);
							}
						}
					});
				},
				deep: true
			}
		},
		created: function() {
			this.getMenuOp()
			this.vip_shareholder_status = this.$store.state.privinfo.vip_shareholder_status
		},
		mounted: function() {
			new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.prs_list_form.shop_id = this.shop_list[0].id
				this.getPrsTable(1)

				this.initDate()
				this.getGoodsPackageType()
            })
		},
		methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = JSON.parse(this.$store.state.menunew);

				menu.forEach(f => {
					if(f.id == '542') {
						menu = f.submenu
						menu.forEach(s => {
							if(s.id == '643') {
								menu = s.submenu
							}
						})
					}
				})
				menu.forEach(_ => {
					if(_.id == '933') {
						_this.list_menu_add = true
					}
					if(_.id == '934') {
						_this.list_menu_modify = true
					}
					if(_.id == '935') {
						_this.list_menu_del = true
					}
				})
			},
			// 获取门店数据
			getShop: function(resolve) {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
                    console.log(err);
					layer.msg('出错啦');
				});
			},
			// 日期
			initDate: function() {
                const _this = this;

                $(_this.$refs.prs_usedate_main).daterangepicker({
					parentEl: '.prs-usedate-wrap',
					// drops: 'up',
					timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
				}, function () {
					event.preventDefault()
					// _this.prs_usedate_start = start.format('YYYY-MM-DD HH:mm');
					// _this.prs_usedate_end = end.format('YYYY-MM-DD HH:mm');
					// _this.prs_usedate_txt = _this.prs_usedate_start + ' ~ ' + _this.prs_usedate_end;
				});

				$(_this.$refs.prs_usedate_main).on('apply.daterangepicker', function(ev, picker) {
			        event.preventDefault()
					_this.prs_usedate_start = picker.startDate.format('YYYY-MM-DD HH:mm');
					_this.prs_usedate_end = picker.endDate.format('YYYY-MM-DD HH:mm');
					_this.prs_usedate_txt = _this.prs_usedate_start + ' ~ ' + _this.prs_usedate_end;
    			});
			},



			// 列表
			getPrsTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('MerchantGoods/searchGoodsPriceList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.prs_list_form.shop_id,
                            "status": _this.prs_list_form.status,
                            "name": _this.prs_list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.prs_total = Number(res.data.response.result.total)
                            _this.prs_page = 1
						}
						_this.prs_table = res.data.response.result.rows;
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				});
            },
            // 删除
			prsDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('MerchantGoods/delGoodsPrice', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功')
							_this.getPrsTable(_this.prs_page)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦')
					});
				});
			},
			// 启用禁用
			prsStatus(id, status) {
				const _this = this;

				layer.confirm('确定执行该操作吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('MerchantGoods/updateGoodsPriceStatus', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id,
                                "status": status
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功')
							_this.getPrsTable(_this.prs_page)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					})
				})
			},
			// 点击新增
			prsAdd() {
                const _this = this
                _this.prs_edit_id = ''
                _this.prs_edit_tit = '新增价格策略'
                _this.prs_edit_form = {
					shop_id: _this.shop_list[0].id,
					shop_disabled: false,
					relate_bill: '',
                    name: '',
                    use_rule: '1',
					forecast_cost_price: '',
					gross_margin_ratio: ''
                }
                new Promise(resolve => {
					_this.prsRoomList(_this.prs_edit_form.shop_id, resolve)
				})
				.then(res => {
					_this.prs_room_txt = ''
					_this.prs_room_item = []
				})
				_this.prs_usedate_txt = ''
				_this.prs_usedate_start = ''
                _this.prs_usedate_end = ''
				_this.prs_usetime_txt = ''
				_this.prs_usetime_start = ''
				_this.prs_usetime_end = ''
                _this.prs_week_txt = '一,二,三,四,五,六,日'
                _this.prs_week_ids = [1, 2, 3, 4, 5, 6, 0]
                _this.prs_week_sign = false
				_this.prs_week_all = true
                _this.edit_goods_page = 1
				_this.edit_goods_table = []
				_this.edit_goods_table_all = []
                _this.showList = false
                _this.showEdit = true
			},
			// 点击修改
			prsModify(id) {
				const _this = this
				// 基本资料
				_this.prs_edit_id = id
                _this.prs_edit_tit = '修改价格策略'
				Vue.axios.post('MerchantGoods/getGoodsPriceDetail', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": _this.prs_edit_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						const row = res.data.response.result
						_this.prs_edit_form = {
							shop_id: row.shop_id,
							shop_disabled: true,
							relate_bill: row.relate_bill,
							name: row.name,
							use_rule: row.use_rule,
							forecast_cost_price: row.forecast_cost_price,
							gross_margin_ratio: row.gross_margin_ratio
						}
						new Promise(resolve => {
							_this.prsRoomList(_this.prs_edit_form.shop_id, resolve)
						})
						_this.prs_room_txt = row.room_name
						_this.prs_room_item = row.room_ids
						_this.prs_usedate_start = row.use_start_time
						_this.prs_usedate_end = row.use_end_time
						_this.prs_usedate_txt = row.use_start_time + '~' + row.use_end_time
						_this.prs_usetime_start = row.use_start_hour
						_this.prs_usetime_end = row.use_end_hour
						_this.prs_usetime_txt = row.use_start_hour + '~' + row.use_end_hour
						_this.prs_week_ids = row.week_cycle.split(',')
						_this.prs_week_sign = _this.prs_week_ids.length > 0 && _this.prs_week_ids.length < _this.week_list.length
						_this.prs_week_all = _this.prs_week_ids.length === _this.week_list.length
						let week_txt = []
						_this.week_list.forEach(_ => {
							_this.prs_week_ids.forEach(item => {
								if(_.id == item) {
									week_txt.push(_.name)
								}
							})
						})
						_this.prs_week_txt = week_txt.join(',')
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
				// 适用商品
				_this.edit_goods_form = {
					goods_type: '',
					goods_name: ''
				}
				_this.edit_goods_add = []
				_this.edit_goods_edit = []
				_this.edit_goods_del = []
				_this.getPrsGoodsDetail()
                _this.showList = false
                _this.showEdit = true
			},
			// 获取适用商品
			getPrsGoodsDetail() {
				const _this = this

				Vue.axios.post('MerchantGoods/getGoodsPriceDetailGoodsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": 0,
							"page_size": 0,
							"id": _this.prs_edit_id,
							"goods_type": _this.edit_goods_form.goods_type,
							"goods_name": _this.edit_goods_form.goods_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
                		_this.edit_goods_page = 1
						_this.edit_goods_table_all = res.data.response.result.rows
						_this.getEditGoodsTable(1)
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
			},
			prsShopChange(val) {
				new Promise(resolve => {
					this.prsRoomList(val, resolve)
				})
				this.prs_room_txt = ''
				this.prs_room_item = []
			},
			// 获取包厢号
			prsRoomList: function(shop_id, resolve) {
				const _this = this;

				Vue.axios.post('Shop/getAllRoomByArea', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.prs_room_arr = res.data.response.result
						_this.prs_room_arr_det = []
						res.data.response.result.forEach(_ => {
							_.room.forEach(item => _this.prs_room_arr_det.push(item))
						})
						resolve()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				})
			},
			// 点击选择包厢号
			prsRoomSelect() {
                this.prs_c_room_item = this.prs_room_item
				this.showEdit = false
				this.showRoom = true
			},
			prsRoomDel() {
				this.prs_room_txt = ''
				this.prs_room_item = []
			},
			// 全选
			prsRoomAll() {
				const _this = this

				if(!_this.prs_room_all) { // 实现全选
					_this.prs_room_item = []
					_this.prs_room_arr_det.forEach(item => {
						_this.prs_room_item.push(item.id)
					})
				} else { // 实现反选
					_this.prs_room_item = []
				}
			},
			// 楼层全选/反选
			prsRoomFloor: function(id, index) {
				const _this = this

				if(_this.prs_room_floor.indexOf(id) == -1) {
					_this.prs_room_arr[index].room.forEach(item => {
						if(_this.prs_room_item.indexOf(item.id) == -1) {
							_this.prs_room_item.push(item.id)
						}
					})
				} else {
					_this.prs_room_arr[index].room.forEach(item => {
						let index = ''
						index = _this.prs_room_item.indexOf(item.id)
						if(index != -1) {
							_this.prs_room_item.splice(index, 1)
						}
					})
				}
			},
			// 确定包厢
			prsRoomSave: function() {
				const _this = this

				if(_this.prs_room_all) {
					_this.prs_room_txt = '全部'
				} else {
					let texts = []
					_this.prs_room_arr_det.forEach(_ => {
						_this.prs_room_item.forEach(item => {
							if(_.id == item) {
								texts.push(_.name)
							}
						})
					})
					_this.prs_room_txt = texts.join(",")
				}
				_this.showEdit = true
				_this.showRoom = false
			},
			// 返回
			prsRoomBack: function() {
				this.prs_room_item = this.prs_c_room_item
				this.showEdit = true
				this.showRoom = false
			},
			prsUsetime: function() {
                const _this = this

				_this.prs_hour_start = _this.prs_usetime_start.split(':')[0] || '00'
				_this.prs_minute_start = _this.prs_usetime_start.split(':')[1] || '00'
				_this.prs_hour_end = _this.prs_usetime_end.split(':')[0] || '00'
				_this.prs_minute_end = _this.prs_usetime_end.split(':')[1] || '00'
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.prs_usetime_alert)
				}, function() {
					_this.prs_usetime_start = _this.prs_hour_start + ":" + _this.prs_minute_start
					_this.prs_usetime_end = _this.prs_hour_end + ":" + _this.prs_minute_end
					_this.prs_usetime_txt = _this.prs_usetime_start + " ~ " + _this.prs_usetime_end
					layer.closeAll()
				})
			},
			// 星期
            prsWeekSelect() {
				const _this = this
                const c_week_ids = _this.prs_week_ids,
                    c_week_sign = _this.prs_week_sign,
                    c_week_all = _this.prs_week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.prs_week_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.prs_week_ids = c_week_ids;
                        _this.prs_week_sign = c_week_sign;
                        _this.prs_week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.prs_week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.prs_week_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.prs_week_ids = c_week_ids;
                    _this.prs_week_sign = c_week_sign;
                    _this.prs_week_all = c_week_all;
                });
            },
            prsWeekDel() {
				this.prs_week_sign = false
                this.prs_week_all = false
				this.prs_week_ids = []
            },
            prsWeekAll(val) {
                let ids = []
				this.week_list.forEach(v => {
					ids.push(v.id)
				});
				this.prs_week_ids = val ? ids : []
				this.prs_week_sign = false
			},
			prsWeekChange(val) {
				const len = val.length
				this.prs_week_sign = len > 0 && len < this.week_list.length
				this.prs_week_all = len === this.week_list.length
			},
			// 适用商品
			getEditGoodsTable(page) {
                this.edit_goods_total = this.edit_goods_table_all.length
                this.edit_goods_table = []
                const len = this.edit_goods_table_all.length > (page * this.GLOBAL.PAGESIZE) ? (page * this.GLOBAL.PAGESIZE) : this.edit_goods_table_all.length
                for(let i = (page - 1) * this.GLOBAL.PAGESIZE; i < len; i++) {
                    this.edit_goods_table.push(this.edit_goods_table_all[i])
                }
			},
			// 添加商品
			getGoodsPackageType() {
				const _this = this;

				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goods_type_list.push({
								id: '-2' + v.id,
								name: v.name,
								type: 'package',
								type_id: v.id
							});
						});
						_this.getGoodsType();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			getGoodsType: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getGoodsType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goods_type_list.push({
								id: v.id,
								name: v.name
							});
							_this.edit_goodstype_list.push({
								id: v.id,
								name: v.name
							});
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			goodsTypeChange(val) {
				this.goods_type_sign = val.type
				if(this.goods_type_sign == 'package') {
					this.goods_type = val.type_id
					this.goods_type_name = val.name
				} else {
					this.goods_type = val.id
					this.goods_type_name = val.name
				}
				this.getGoodsTable(1)
			},
			getGoodsTable: function(page) {
				const _this = this

				_this.goods_loading = true
				_this.goods_page = page
				let url = "merchantGoods/searchMerchantGoodsList"
				let data = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							"shop_id": _this.prs_edit_form.shop_id,
							"goods_type": _this.goods_type,
							"goods_name": _this.goods_name,
							"status": '1'
						}
					},
					"comment": ""
				};
				if(_this.goods_type_sign == 'package') {
					url = "merchantGoods/searchMerchantGoodsPackage";
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.goods_total = Number(res.data.response.result.data.total);
						}
						if(_this.goods_type_sign == 'package') {
							_this.goods_columns = [{
								"prop": 'name',
								"label": '名称'
							}, {
								"prop": 'package_unit_name',
								"label": '单位'
							}]
						} else {
							_this.goods_columns = [{
								"prop": 'goods_name',
								"label": '名称'
							}, {
								"prop": 'goods_unit_name',
								"label": '单位'
							}]
						}
						_this.goods_table = res.data.response.result.data.rows;
						_this.goods_loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			getSelectGoods(val) {
				this.goods_table_select = val
			},
			// 添加商品
			goodsSelect: function() {
				const _this = this;

				_this.goods_type = '';
				_this.goods_type_name = '';
				_this.goods_type_sign = '';
				_this.goods_name = '';
				_this.goods_page = 1;
				_this.getGoodsTable(1);
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加商品', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.goods_alert)
                }, function() {
					// 保存商品
					if(_this.goods_type_sign == 'package') {
						_this.goods_table_select.forEach(_ => {
							let isTrue = true;
							for(let i = 0; i < _this.edit_goods_table_all.length; i++) {
								if(_this.edit_goods_table_all[i].goods_id == _.id && _this.edit_goods_table_all[i].goods_type == '0') {
									isTrue = false;
								}
							}
							if(isTrue) {
								_this.edit_goods_table_all.push({
									"goods_id": _.id,
									"goods_name": _.name,
									"goods_type": '0',
									"goods_type_name": '商品套餐',
									"good_img": _.img_url,
									"goods_unit_name": _.package_unit_name,
									"discount_price": _.actual_price,
									"vip_price": _.vip_price,
									"vip_level1_price": _.vip_level1_price,
									"vip_level2_price": _.vip_level2_price,
									"vip_level3_price": _.vip_level3_price,
									"vip_level4_price": _.vip_level4_price,
									"vip_level5_price": _.vip_level5_price,
									"vip_level6_price": _.vip_level6_price,
									"vip_level7_price": _.vip_level7_price,
									"vip_level8_price": _.vip_level8_price,
									"vip_level9_price": _.vip_level9_price,
									"vip_level10_price": _.vip_level10_price,
									"cost_price": _.cost_price
								})
								// 修改状态
								if(_this.prs_edit_id) {
									_this.edit_goods_add.push({
										"goods_id": _.id,
										"goods_name": _.name,
										"goods_type": '0',
										"goods_type_name": '商品套餐',
										"good_img": _.img_url,
										"goods_unit_name": _.package_unit_name,
										"discount_price": _.actual_price,
										"vip_price": _.vip_price,
										"vip_level1_price": _.vip_level1_price,
										"vip_level2_price": _.vip_level2_price,
										"vip_level3_price": _.vip_level3_price,
										"vip_level4_price": _.vip_level4_price,
										"vip_level5_price": _.vip_level5_price,
										"vip_level6_price": _.vip_level6_price,
										"vip_level7_price": _.vip_level7_price,
										"vip_level8_price": _.vip_level8_price,
										"vip_level9_price": _.vip_level9_price,
										"vip_level10_price": _.vip_level10_price,
										"cost_price": _.cost_price
									})
								}
							}
						})
					} else {
						_this.goods_table_select.forEach(_ => {
							let isTrue = true;
							for(let i = 0; i < _this.edit_goods_table_all.length; i++) {
								if(_this.edit_goods_table_all[i].goods_id == _.id && _this.edit_goods_table_all[i].goods_type == _.goods_type) {
									isTrue = false;
								}
							}
							if(isTrue) {
								_this.edit_goods_table_all.push({
									"goods_id": _.id,
									"goods_name": _.goods_name,
									"goods_type": _.goods_type,
									"goods_type_name": _.goods_type_name,
									"good_img": _.good_img,
									"goods_unit_name": _.goods_unit_name,
									"discount_price": _.discount_price,
									"vip_price": _.vip_price,
									"vip_level1_price": _.vip_level1_price,
									"vip_level2_price": _.vip_level2_price,
									"vip_level3_price": _.vip_level3_price,
									"vip_level4_price": _.vip_level4_price,
									"vip_level5_price": _.vip_level5_price,
									"vip_level6_price": _.vip_level6_price,
									"vip_level7_price": _.vip_level7_price,
									"vip_level8_price": _.vip_level8_price,
									"vip_level9_price": _.vip_level9_price,
									"vip_level10_price": _.vip_level10_price,
									"cost_price": _.cost_price
								})
								// 修改状态
								if(_this.prs_edit_id) {
									_this.edit_goods_add.push({
										"goods_id": _.id,
										"goods_name": _.goods_name,
										"goods_type": _.goods_type,
										"goods_type_name": _.goods_type_name,
										"good_img": _.good_img,
										"goods_unit_name": _.goods_unit_name,
										"discount_price": _.discount_price,
										"vip_price": _.vip_price,
										"vip_level1_price": _.vip_level1_price,
										"vip_level2_price": _.vip_level2_price,
										"vip_level3_price": _.vip_level3_price,
										"vip_level4_price": _.vip_level4_price,
										"vip_level5_price": _.vip_level5_price,
										"vip_level6_price": _.vip_level6_price,
										"vip_level7_price": _.vip_level7_price,
										"vip_level8_price": _.vip_level8_price,
										"vip_level9_price": _.vip_level9_price,
										"vip_level10_price": _.vip_level10_price,
										"cost_price": _.cost_price
									})
								}
							}
						})
					}
					_this.getEditGoodsTable(_this.edit_goods_page)
					_this.$refs.goods_table.clearSelection()
					layer.msg('保存成功')
                });
			},
			// 修改商品
            editGoodsPrice(row, key, value) {
				const _this = this
				if(_this.prs_edit_id) {
					const index = _this.edit_goods_add.findIndex(_ => _.goods_id === row.goods_id)
					if(index === -1) {
						_this.edit_goods_edit.push(row)
					} else {
						_this.edit_goods_add[index][key] = value
					}
				}
                _this.edit_goods_table_all[_this.edit_goods_table_all.findIndex(_ => _.goods_id === row.goods_id)][key] = value
                _this.getEditGoodsTable(_this.edit_goods_page)
            },
            // 删除商品
            editGoodsDel(row) {
				const _this = this
				if(_this.prs_edit_id) {
					const index = _this.edit_goods_add.findIndex(_ => _.goods_id === row.goods_id)
					if(index === -1) {
						_this.edit_goods_del.push(row)
					} else {
						_this.edit_goods_add.splice(index, 1)
					}
				}
                _this.edit_goods_table_all.splice(_this.edit_goods_table_all.findIndex(_ => _.goods_id === row.goods_id), 1)
                _this.getEditGoodsTable(_this.edit_goods_page)
			},
			// 添加、修改
			prsEdit: function(addModify) {
				const _this = this
				if(_this.prs_edit_form.name == '') {
					layer.msg('请输入策略名称')
					return false
				} else if(_this.prs_edit_form.prs_room_txt == '') {
					layer.msg('请选择适用包厢')
					return false
				} else if(_this.prs_week_ids.length == 0) {
					layer.msg('请选择有效星期日')
					return false
				} else if(_this.edit_goods_table_all.length == 0) {
					layer.msg('请添加适用商品')
					return false
				}

				let url = 'MerchantGoods/addGoodsPrice'
				let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.prs_edit_form.shop_id,
							"name": _this.prs_edit_form.name,
							"relate_bill": _this.prs_edit_form.relate_bill,
							"room_ids": _this.prs_room_item,
							"use_start_time": _this.prs_usedate_start,
							"use_end_time": _this.prs_usedate_end,
							"use_start_hour": _this.prs_usetime_start,
							"use_end_hour": _this.prs_usetime_end,
							"week_cycle": _this.prs_week_ids.join(),
							"use_rule": _this.prs_edit_form.use_rule,
							"forecast_cost_price": _this.prs_edit_form.forecast_cost_price,
							"gross_margin_ratio": _this.prs_edit_form.gross_margin_ratio,
							"goods_add": _this.edit_goods_table_all
						}
					},
					"comment": ""
                }
                if(_this.prs_edit_id) {
					url = 'MerchantGoods/editGoodsPrice'
                    data.request.param.id = _this.prs_edit_id
                    data.request.param.goods_add = _this.edit_goods_add
                    data.request.param.goods_edit = _this.edit_goods_edit
                    data.request.param.goods_del = _this.edit_goods_del
                }
                Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功')
						_this.getPrsTable(_this.prs_page)
						_this.showList = true
						_this.showEdit = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            // 返回
            prsBack() {
                this.showList = true
                this.showEdit = false
            },
		}
	}
</script>
<style lang="less" scoped>
	.prs-list {
		p {
			margin: 20px 0;
			color: #FF0707;
		}
	}
	.prs-edit {
		>p {
			margin: 20px 0;
			color: #FF0707;
		}
		h3 {
			margin: 0 0 20px;
			font-size: 18px;
		}
		.el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
		}
		.prs-edit-base {
			padding: 20px;
			margin: 20px 0;
			background: #f5f5f5;
			.el-checkbox {
				margin-left: 10px;
			}
		}
		.prs-edit-goods {
			padding: 20px;
			margin: 20px 0;
			background: #f5f5f5;
            .el-select {
                width: 200px;
            }
            .el-input {
                width: 200px;
            }
			.edit-goods-img {
				display: block;
				width: 50px;
			}
			.prs-table-input {
				width: 100%;
			}
		}
    }
    .select-goods-wrap {
        display: none;
    }
</style>